import DiagramService from '../services/diagram.service';

const onlyUnique = function (value, index, self) {
  return self.indexOf(value) === index;
};

const extractData = function (arr, level, category) {
  const data = [];
  let color = [];
  const sublevels = [];
  arr.forEach((item) => {
    if (item.level === level && item.category === category) {
      color = item.color;
      sublevels.push(item.sublevel);
      data.push({
        name: item.subcategory,
        details: item.details,
        level,
        category,
        sublevel: item.sublevel,
      });
    }
  });
  return {
    data,
    color,
    sublevels: sublevels.filter(onlyUnique),
  };
};

export default {
  namespaced: true,
  state: {
    diagram: [],
    item: {},
    isDetailsModalOpen: false,
  },
  mutations: {
    diagram(state, payload) {
      state.diagram = payload;
    },
    item(state, payload) {
      state.item = payload;
    },
    isDetailsModalOpen(state, payload) {
      state.isDetailsModalOpen = payload;
    },
  },
  actions: {
    getDiagram({ commit }) {
      DiagramService.getDiagram()
        .then((res) => commit('diagram', res));
    },
  },
  getters: {
    levels(state) {
      const levels = [];
      state.diagram.forEach((item) => levels.push(item.level));
      return levels.filter(onlyUnique);
    },
    macroInputs(state) {
      return extractData(state.diagram, 'Macro', 'Inputs');
    },
    macroProcesses(state) {
      return extractData(state.diagram, 'Macro', 'Processes');
    },
    macroOutcomes(state) {
      return extractData(state.diagram, 'Macro', 'Outcomes');
    },
    mesoInputs(state) {
      return extractData(state.diagram, 'Meso', 'Inputs');
    },
    mesoProcesses(state) {
      return extractData(state.diagram, 'Meso', 'Processes');
    },
    mesoOutcomes(state) {
      return extractData(state.diagram, 'Meso', 'Outcomes');
    },
    microInputs(state) {
      return extractData(state.diagram, 'Micro', 'Inputs');
    },
    microProcesses(state) {
      return extractData(state.diagram, 'Micro', 'Processes');
    },
    microOutcomes(state) {
      return extractData(state.diagram, 'Micro', 'Outcomes');
    },
  },
};
